// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apiErrorNotification_notification__VrpfY {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 20000;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  width: min(32rem, 100vw - 2rem);
  padding: 1rem 1.25rem;
  border-left: 5px solid #b42318;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);
  color: #252525;
  font-size: 1rem;
}

.apiErrorNotification_dismiss__bQJ5b {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 1.5rem;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/styles/apiErrorNotification.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,+BAAA;EACA,qBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ","sourcesContent":[".notification {\n    position: fixed;\n    top: 1rem;\n    right: 1rem;\n    z-index: 20000;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n    width: min(32rem, calc(100vw - 2rem));\n    padding: 1rem 1.25rem;\n    border-left: 5px solid #b42318;\n    border-radius: 6px;\n    background: #fff;\n    box-shadow: 0 4px 18px rgb(0 0 0 / 20%);\n    color: #252525;\n    font-size: 1rem;\n}\n\n.dismiss {\n    flex: 0 0 auto;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    cursor: pointer;\n    font-size: 1.5rem;\n    line-height: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notification": `apiErrorNotification_notification__VrpfY`,
	"dismiss": `apiErrorNotification_dismiss__bQJ5b`
};
export default ___CSS_LOADER_EXPORT___;
